<table mat-table
       [dataSource]="dataSource" multiTemplateDataRows
       class="table-desktop">

  <ng-container matColumnDef="{{column.name}}" *ngFor="let column of columns">
    <ng-container *ngIf="column.valueControl !== FormControlType.CHECKBOX; else thCheckbox ">
      <th mat-header-cell *matHeaderCellDef [width]="column.width? column.width : null"
          [style.padding]="column.padding? column.padding: null">
        <ng-container class="columns" *ngIf="column.label?.length; else t1">
          {{column.label}}
        </ng-container>
        <ng-template #t1  class="columns" >
          <span class="cdk-visually-hidden">{{column.name}}</span>
        </ng-template>

      </th>
    </ng-container>
    <ng-template #thCheckbox>
      <th mat-header-cell *matHeaderCellDef [width]="column.width? column.width : null" style="text-align: center">
        <ng-container class="columns" *ngIf="column.label?.length; else t2">
          {{column.label}}
        </ng-container>
        <ng-template #t2  class="columns" >
          <span class="cdk-visually-hidden">{{column.name}}</span>
        </ng-template>
      </th>
    </ng-template>


    <td mat-cell *matCellDef="let element" [ngStyle]="{'max-width': column.maxWidth ? column.maxWidth : null}"
        [style.padding]="column.padding? column.padding: null"
        [matTooltip]="column.showTooltip ?  element[column.name] : null">
      <div [ngClass]="{'columns': editedRow !== element }"
           [ngStyle]="column.style!==undefined ? column.style(element): '' ">
        <ng-container *ngIf="column.iconBefore">
          <ng-container *ngTemplateOutlet="iconBefore">
          </ng-container>
        </ng-container>
        <ng-container *ngIf="column.prefix">{{ column.prefix }}</ng-container>

        <ng-container *ngIf="column.isHtml; else td">
          <div [innerHTML]=" element[column.name]| safeHtml"
               [ngStyle]="column.style!==undefined ? column.style(element): '' "></div>
        </ng-container>
        <ng-template #td>
          <ng-container *ngIf="(editedRow === element && column.formControl) ||
          (editedRow !== element && column.valueControl); else tdValue">
            <ng-container [ngSwitch]="column.formControl">
              <ng-container *ngSwitchCase="FormControlType.CHECKBOX" [ngTemplateOutlet]="tdCheckbox"></ng-container>
              <ng-container *ngSwitchDefault [ngTemplateOutlet]="tdInput"></ng-container>
            </ng-container>
          </ng-container>

          <ng-template #tdCheckbox>
            <div style="width: 100%; text-align: center">
              <mat-checkbox *ngIf="editedRow !== element" enterTogglesCheckbox
                            [indeterminate]="checkboxIndeterminate(element, column.name)"
                            [checked]="checkboxChecked(element,column.name)"
                            [value]="checkboxValue(element, column.name)"
                            aria-label="Zaznacz/Odznacz"
                            [disabled]="true">
                <span class="cdk-visually-hidden">Zaznacz/Odznacz</span>
              </mat-checkbox>
              <mat-checkbox *ngIf="editedRow === element" enterTogglesCheckbox
                            aria-label="Zaznacz/Odznacz"
                            [checked]="checkboxChecked(changingRow, column.name)"
                            [indeterminate]="checkboxIndeterminate(changingRow, column.name)"
                            [value]="checkboxValue(changingRow, column.name)"
                            (change)="toggleCheckbox(changingRow, column.name)"
                            [disabled]="false">
                <span class="cdk-visually-hidden">Zaznacz/Odznacz</span>
              </mat-checkbox>

            </div>
          </ng-template>
          <ng-template #tdInput>
            <input *ngIf="editedRow !== element"
                   matInput type="text" style="width: calc(100% - 12px)"
                   [value]="element[column.name]" [disabled]="true" />

            <input *ngIf="editedRow === element"
                   matInput type="text" style="width: calc(100% - 12px)"
                   [(ngModel)]="changingRow[column.name]" [disabled]="false"
                   autocomplete="off" />

          </ng-template>
          <ng-template #tdValue>
            <ng-container *ngIf="column.pipe ; else valueWithoutPipe">
              {{ column.pipe.transform(element[column.name], column.pipeParam) }}
            </ng-container>
            <ng-template #valueWithoutPipe>
              <ng-container *ngIf="column.name==='billerName'; else notBillerName">
                <div *ngIf="isApple() && column.name==='billerName' && element.firstInCurrentMonth"
                     class="show-month">
                  <span>
                    Bieżący miesiąc
                  </span>
                </div>
                <div [style]="{overflow: 'hidden', 'max-width': '240px', width: '240px' }">
                  {{ element[column.name] }}
                </div>
              </ng-container>
              <ng-template #notBillerName>
                {{ element[column.name] }}
              </ng-template>

            </ng-template>
          </ng-template>
        </ng-template>
        <ng-container *ngIf="column.sufix">{{ column.sufix }}</ng-container>
        <ng-container *ngIf="column.iconAfter">
          <ng-container *ngTemplateOutlet="iconAfter">
          </ng-container>
        </ng-container>
        <ng-template #iconBefore>
          <app-icon [name]="column.iconBefore" width="8" height="8"
                    [ngStyle]="column.iconBeforeStyle(element)"></app-icon>
        </ng-template>
        <ng-template #iconAfter>
          <app-icon [name]="column.iconAfter" width="8" height="8"
                    [ngStyle]="column.iconAfterStyle(element)"></app-icon>
        </ng-template>
      </div>

    </td>
  </ng-container>
  <ng-container matColumnDef="checkboxSelect">
    <th mat-header-cell *matHeaderCellDef [width]="'45px'">
      <mat-checkbox
        *ngIf="!multiselectDisabled"
        [disabled]="isSelectAllDisabled" enterTogglesCheckbox
        (change)="$event ? onToggleAll() : null"
        [checked]="hasSelectedValue && isAllSelected()"
        [indeterminate]="(hasSelectedAnotherValue || hasSelectedValue) && !isAllSelected()"
        [aria-label]="checkboxLabel()">
        <span class="cdk-visually-hidden">Zaznacz/Odznacz wszystkie</span>

      </mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let element" (click)="checkboxClick($event, element)"
        [ngStyle]="{'cursor': !isCheckboxSelectionDisabled(element) ? 'pointer' : null}">

      <mat-checkbox
        (click)="$event.stopPropagation()" enterTogglesCheckbox
        (change)="$event ? toggleElement(element): null"
        [disabled]="isCheckboxSelectionDisabled(element)"
        [checked]="isSelected(element)"
        [aria-label]="checkboxLabel(element)">
        <span class="cdk-visually-hidden">Zaznacz/Odznacz</span>
      </mat-checkbox>
    </td>

  </ng-container>
  <ng-container matColumnDef="editableMenu">
    <th mat-header-cell *matHeaderCellDef [width]="'80px'">
      <span class="cdk-visually-hidden">Menu</span>
    </th>
    <td mat-cell *matCellDef="let element">
      <button
        aria-label="Edytuj"
        *ngIf="!editedRow"
        mat-icon-button (click)="editElement(element)">
        <span class="cdk-visually-hidden">Edytuj</span>
        <app-icon name="edit"></app-icon>
      </button>
      <ng-container *ngIf="editedRow && (editedRow === element)">
        <div class="flex" fxLayout="row">
          <button
            aria-label="Anuluj"
            mat-icon-button (click)="cancelEditing()">
            <span class="cdk-visually-hidden">Anuluj</span>
            <app-icon name="cancel"></app-icon>
          </button>
          <button
            aria-label="Zapisz"
            mat-icon-button (click)="saveEditedElement()">
            <span class="cdk-visually-hidden">Zapisz</span>
            <app-icon name="check_circle"></app-icon>
          </button>

        </div>
      </ng-container>

    </td>
  </ng-container>

  <ng-container matColumnDef="expandableMenu">
    <th mat-header-cell *matHeaderCellDef [width]="'42px'">
      <span class="cdk-visually-hidden">Menu</span>
    </th>
    <td mat-cell *matCellDef="let element" style="position: relative" (click)="expandableMenuTdClick($event)">
      <app-liability-expandable-menu-table
        (click)="blockEvents($event)"
        [disabled]="false"
        [liability]="element"
        [startedPaymentId]="startedPaymentId"
        style="width: 48px;"
        (liabilityMarkedAsPaidEvent)="liabilityMarkedAsPaidEvent.next()"
      ></app-liability-expandable-menu-table>
    </td>
  </ng-container>

  <ng-container matColumnDef="expanded">
    <th mat-header-cell *matHeaderCellDef><span class="cdk-visually-hidden">Menu</span></th>
    <td mat-cell *matCellDef="let element">
      <div>
        <button
          aria-label="Rozwiń"
          mat-icon-button (click)="(expandedElement === element ? hideRow():
        expandRow(element));
              $event.stopPropagation()">
          <app-icon *ngIf="expandedElement !== element" name="keyboard_arrow_down"></app-icon>
          <app-icon *ngIf="expandedElement === element" name="keyboard_arrow_up"></app-icon>
        </button>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element"
        [attr.colspan]="columns.length"
        [ngStyle]="{'background-color': isEven(element) ? 'white' : '#F6F6F6'}">
      <ng-container *ngIf="expandedElement===element">
        <div style="display: flex;" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
          <div class="element-detail text-sm">
            <app-expanded-row *ngIf="expandedElement" [element]="expandedElement"
                              [expandedComponent]="expandedComponent"></app-expanded-row>
          </div>
        </div>

      </ng-container>
    </td>
  </ng-container>
  <ng-container matColumnDef="expandedDetails2">
    <td mat-cell *matCellDef="let element"
        [attr.colspan]="1"
        [ngStyle]="{'background-color': isEven(element) ? 'white' : '#F6F6F6',
        'position': 'relative', 'padding': '1px 1px 1px 0'}">
      <div *ngIf="element === expandedElement" class="vertical-expanded-line"></div>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="columnsDesktopNames"></tr>
  <ng-container *ngIf="!isExpandable; else expandedRows">
    <tr mat-row *matRowDef="let element; columns: columnsDesktopNames;"
        [ngClass]="{
        'even-row':  isEven(element),
         'odd-row': !isEven(element),
         'show-data-name': !isApple() && element.firstInCurrentMonth
        } "
        [ngStyle]="rowStyle ?  rowStyle(element): {}"
        (mouseenter)="this.hoverElement(element)"
        (mouseleave)="this.unhoverElement(element)"
        [attr.data-name]="element.firstInCurrentMonth ? 'Bieżący miesiąc' : null"
        (click)="rowOnclick.next(element)">
    </tr>

  </ng-container>
  <ng-template #expandedRows>
    <tr mat-row *matRowDef="let element; columns: columnsDesktopNames;"
        [ngStyle]="rowStyle ?  rowStyle(element): {}"
        [ngClass]="{
        'even-row':  isEven(element),
         'odd-row': !isEven(element),
         'show-data-name': !isApple() && element.firstInCurrentMonth
        } ">
    </tr>

    <tr mat-row *matRowDef="let row; columns: ['expandedDetail', 'expandedDetails2']" class="example-detail-row"></tr>
  </ng-template>
</table>
<mat-paginator #paginator
               *ngIf="pageable"
               (page)="handlePageEvent($event)"
               [pageSizeOptions]="[5, 10, 20]"
               [pageSize]="pageSize? pageSize: 10"
               [length]="totalCount"
               [title]="'test'"
               [pageIndex]="pageIndex"
               showFirstLastButtons
               aria-label="Select page of periodic elements">
</mat-paginator>
